export default function getMappings(mappingCards: any[]) {
  return mappingCards.reduce((acc, mappingCard) => {
    mappingCard.mappings.forEach((mapping: any) => {
      acc.push(mapping);
    });

    return acc;
  }, []);
}
